import React from 'react'
import { Box, Checkbox, styled } from '@mui/material'
import { Text2 } from '../styleds'

import { ReactComponent as BpIcon } from '@/assets/imgs/home/bpIcon.svg'
import { ReactComponent as BpCheckedIcon } from '@/assets/imgs/home/bpCheckedIcon.svg'

export const CheckRowWrapper = styled(Box)`
  display: flex;
  width: 100%;
  padding: 12px;
  align-items: flex-start;
  align-self: flex-start;
  column-gap: 4px;
  background: rgba(250, 81, 111, 0.1);
  margin-top: 40px;
`

interface CheckProps {
  value: boolean
  toggle: () => void
}

const Check = ({ value, toggle }: CheckProps) => {
  return (
    <CheckRowWrapper sx={{ mt: 20 }}>
      <Checkbox
        sx={{
          '&:hover': { bgcolor: 'transparent' },
          p: 0,
        }}
        disableRipple
        checked={value}
        onChange={toggle}
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
      />
      <Text2 color="#FA516F">I have learned that service is only available to non-U.S. persons and entities.</Text2>
    </CheckRowWrapper>
  )
}

export default Check
